import { Module } from "wrapper6";

var $ = jQuery;

export default class Dealers extends Module {

    ready(app) {

        this.WRAPPER = document.querySelector('.mtt-dealers');

		if (this.WRAPPER) {

            this.DEALER_MARKERS = window.dealer_map_markers; // get dealers from window object
            this.DEALERS = document.querySelectorAll('.dealer-card');
			this.TARGET = document.querySelector('.mtt-dealers__dealers');
			this.CATEGORY_SELECT = document.querySelector('.mtt-dealers-filter #categories-filter');
			this.LOADER = this.WRAPPER.querySelector('.mtt-dealers__loader');
			this.ERROR = this.WRAPPER.querySelector('.mtt-dealers__error-message');
	
			this.data = {
				'category': '0'
            };

            this.CATEGORY_SELECT && this.categoryHandler();
        }
    }

    categoryHandler() {
		this.CATEGORY_SELECT.addEventListener('change', () => {
            this.data.category = this.getSelectedOption(this.CATEGORY_SELECT);
            this.filterDealers();
		});
    }
    
    getSelectedOption(SELECT) {
		return SELECT ? SELECT.options[SELECT.selectedIndex].value : '0';
    }
    
    filterDealers() {

        this.showLoader();

        if (this.DEALERS) {

            let count = this.DEALERS.length;

            for (let i = 0; i < this.DEALERS.length; i++) {
                const DEALER = this.DEALERS[i];

                let categories = DEALER.getAttribute('data-categories');
                categories = categories.split(', ');

                
                // check if dealer has category and brand
                if (categories.indexOf(this.data.category) != -1) {
                    DEALER.classList.remove('dealer-card--hide');
                    this.DEALER_MARKERS.length > 0 && this.DEALER_MARKERS[i].setVisible(true);
                } else {
                    DEALER.classList.add('dealer-card--hide');
                    this.DEALER_MARKERS.length > 0 && this.DEALER_MARKERS[i].setVisible(false);
                    count--;
                }

                if (count === 0) {
                    this.ERROR ? this.ERROR.classList.add('mtt-dealers__error-message--show') : '';
                } else {
                    this.ERROR ? this.ERROR.classList.remove('mtt-dealers__error-message--show') : '';
                }
            }
        }

        setTimeout(() => {
            this.hideLoader();
        }, 300);
    }

    showLoader() {
		if (this.LOADER) this.LOADER.classList.add('loader--show');
	}

	hideLoader() {
		if (this.LOADER) this.LOADER.classList.remove('loader--show');
	}
}